// Add a Note: Yes/No indicator row to an existing ConfirmationDetail row
// so the wizard summary reflects whether the user attached a draft note.
// The full body lives in the audit trail post-flush — the summary only
// needs presence/absence.
import { TFunction } from "i18next";

import { ConfirmData } from "@components/shared/ConfirmationDetail";
import { DraftNote, isEmptyDraftNote } from "./NoteComposer";

export function mergeDraftNoteIntoRow(
  row: ConfirmData,
  draftNote: DraftNote | null | undefined,
  t: TFunction,
  // Title to use when a note is attached. Defaults to the evidence-step
  // i18n key ("Note & supporting evidence"). Pass the original row title
  // for wizards whose note doesn't share a step with evidence (e.g.
  // SpecialAnnouncement merges into its Details row).
  mergedTitle?: string,
): ConfirmData {
  const hasNote = !isEmptyDraftNote(draftNote);

  return {
    ...row,
    title: hasNote ? mergedTitle ?? t("evidence.note_and_supporting") : row.title,
    body: [
      {
        key: t("notes.body_label"),
        value: hasNote ? t("common.yes") : t("common.no"),
      },
      ...row.body,
    ],
  };
}
